/*jshint esversion: 6 */

import DebugUtils from '../common/debug'
const _debug = DebugUtils({debug: true}).log;

let _d = function (message) {
    _debug('WidgetBespokeNewsPage:: ' + message);
};

let WidgetBespokeNewsPage = function(){

    let hideThumb = function () {
        let thumb = document.querySelector('.article > img');
        if(thumb)
        {
            _d('hiding thumb')
            thumb.setAttribute('style', 'display: none;');
        }
    }

    let hideDonateSnippet = function () {
        let snippet = document.querySelector('.donate.snippet');
        if(snippet)
        {
            _d('hiding donate snippet')
            snippet.setAttribute('style', 'display: none;');
        }
    }

    let changePageTitle = function (title, destinationSelector) {
        _d('change page title')
        title = title || document.querySelector('.content-item-title').textContent;
        destinationSelector = destinationSelector || 'h1.page-title';
        if (title) {
            document.querySelector(destinationSelector).textContent = title;
        }
    }

    let removeVariousElements = function () {
        _d('remove various elements')
        let elem = document.querySelector('div.content-specific-nav');
        if (elem) {
            elem.parentNode.removeChild(elem);
        }
        elem = document.querySelector('div.content-specific-search');
        if (elem) {
            elem.parentNode.removeChild(elem);
        }
        elem = document.querySelector('h1.content-item-title');
        if (elem) {
            elem.parentNode.removeChild(elem);
        }
    }

    let putRegistrationLinkInLeftSidebar = function () {
        _d('put registration link in left sidebar')

        // remove the left sidebar
        let elem = document.querySelector('.left .sidebar');
        if(elem)
        {
            elem.parentNode.removeChild(elem);
        } else {
            _d('Warning: left sidebar found by selector: .left .sidebar');
        }

        // create a link to registration in left sidebar
        let sidebar = document.querySelector('.left');
        if(sidebar)
        {
            let cta = document.querySelector('.hidden.registration-button');
            if (cta) {
                sidebar.appendChild(cta);
                cta.classList.remove('hidden');
            } else {
                _d('Warning: cta not found by selector: .hidden.registration-button');
            }
        } else {
            _d('Warning: left sidebar not found by selector: .left');
        }
    }

    let removeLeftSidebar = function () {
        _d('remove left sidebar')

        // first selector attempt
        let elem = document.querySelector('.left .sidebar');
        if(elem)
        {
            elem.parentNode.removeChild(elem);
            return;
        }

        elem = document.querySelector('#page-content .content-news-item .left');
        if(elem)
        {
            elem.parentNode.removeChild(elem);
            return;
        }
        _d('Warning: left sidebar not found by selectors: ".left .sidebar" or "#page-content .content-news-item .left"');
    }

    let removeRightSidebar = function () {
        _d('remove right sidebar')

        // first selector attempt
        let elem = document.querySelector('.right .sidebar');
        if(elem)
        {
            elem.parentNode.removeChild(elem);
            return;
        }

        elem = document.querySelector('#page-content .content-news-item .right');
        if(elem)
        {
            elem.parentNode.removeChild(elem);
            return;
        }
        _d('Warning: right sidebar not found by selectors: ".right .sidebar" or "#page-content .content-news-item .right"');
    }

    let goFullWidth = function () {
        _d('go full width')

        // first selector attempt
        let elem = document.querySelector('.content-news-item div:first-child');
        if(elem)
        {
            if (elem.classList.contains('col-lg-8')) {
                elem.classList.remove('col-lg-8');
                elem.classList.add('col-lg-12');
            }
        }

    }

    let putBannerInRightSidebar = function () {
        _d('put banner in right sidebar')

        // remove the right side items (not the banner)

        let elem = document.querySelector('.right .sidebar h3');
        if(elem)
        {
            elem.parentNode.removeChild(elem);
        }

        elem = document.querySelector('.right .sidebar .widget-list-news');
        if(elem)
        {
            elem.parentNode.removeChild(elem);
        }

        // move the banner to the right sidebar
        let rsidebar = document.querySelector('.right .sidebar');

        if(rsidebar)
        {
            let banner = document.querySelector('.ajax.banner');
            if(banner)
            {
                rsidebar.appendChild(banner);
                banner.classList.remove('hidden');
            } else {
                _d('Warning: there is no banner to move');
            }
        } else {
            _d('Warning: right sidebar not found by selector: .right .sidebar');
        }
    }

    let changeClassAddThis = function () {
        _d('add class to AddThis');
        let elem = document.querySelector('.addThis');
        if(elem)
        {
            elem.classList.add('snippet');
        }
    }

    let modifyPage = function(){
        _d('modifyPage()');
        hideThumb()
        // hideDonateSnippet(); // for some reason we are not doing this
        changePageTitle();
        removeVariousElements();
        putRegistrationLinkInLeftSidebar();
        putBannerInRightSidebar();
        changeClassAddThis();
    }

    let hide = function (selector) {
        let elems = document.querySelectorAll(selector);
        _d(`hide: ${selector} found ${elems.length} elements`);
        for (const elem of elems) {
            elem.setAttribute('style', 'display: none;');
        }
    }

    return {
        hideThumb: hideThumb,
        hideDonateSnippet: hideDonateSnippet,
        changePageTitle: changePageTitle,
        removeVariousElements: removeVariousElements,
        putRegistrationLinkInLeftSidebar,
        hide,
        removeLeftSidebar,
        removeRightSidebar,
        goFullWidth,
        putBannerInRightSidebar: putBannerInRightSidebar,
        changeClassAddThis: changeClassAddThis,
        modifyPage: modifyPage
    };

};


export default WidgetBespokeNewsPage;
